'use client';
import {useEffect} from 'react';
import Cookies from 'js-cookie';
import {useSearchParams} from 'next/navigation';

export default function ReferralCookieManager() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const referralCode = searchParams.get('referral');
    if (referralCode) {
      Cookies.set('referral', referralCode, {expires: 30}); // Salva il cookie per 30 giorni
    }
  }, [searchParams]);

  return null;
}
